import type { ArticleAttributeApiData } from "./";
import { ArticleAttribute } from "./";

export class GenericArticleAttribute extends ArticleAttribute {
  public constructor(apiData: ArticleAttributeApiData) {
    super(apiData);
  }
}

export default GenericArticleAttribute;
